<template>
    <v-app>
        <v-app-bar 
            app
            color="primary"
            elevation="2"
            height="60"
        > 
            <div class="appbar-logo ml-3 flex-grow-0">
                <v-img
                    alt="School Logo"
                    contain
                    src="../assets/logo.png"
                    transition="scale-transition"
                    width="40"
                />
            </div>

            <v-toolbar-title class="appbar-title ml-3 white--text">
                {{  schoolName }}
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <div class="appbar-actions pr-3">
                <div class="term-badge">
                    <v-icon size="13" color="rgba(255, 255, 255, 0.8)">mdi-calendar-month</v-icon>
                    <span>{{ currentAcademicPeriod }}</span>
                </div>
            </div>

            <v-avatar size="32" class="user-avatar">
                <span>{{ initials }}</span>
            </v-avatar>

            <Logout/>
        </v-app-bar>

        <v-main class="main-bg">
            <div class="welcome-header">
                <p class="welcome-eyebrow">Staff Portal</p>
                <h1 class="welcome-heading">
                    Welcome back, <em class="welcome-name">{{ user }}</em>
                </h1>
            </div>

            <v-container
                class="dashboard-container"          
            >
                <p class="section-label">Dashboard</p>    
            
                <v-row>
                    <v-col
                        cols="1"
                    >
                        <v-card
                            width="180"
                            flat
                            color="#F0F2F8"
                            class="d-flex flex-column align-center"
                            v-if="!mainMenu"
                        >
                            <v-expand-transition>
                                <v-btn
                                    color="primary"
                                    dark
                                    fab
                                    small
                                    @click="showMainMenu"    
                                >
                                    <v-icon>
                                        mdi-arrow-left
                                    </v-icon>
                                    
                                </v-btn>
                            </v-expand-transition>
                            <div
                                class=" mt-2" style="font-size:0.7rem"
                            >
                                Main Menu
                            </div>
                        </v-card>
                    </v-col>

                    <v-col
                        cols="11"
                    >
                        <main-menu v-if="mainMenu"></main-menu>
                        <mark-sheet v-if="markSheet"></mark-sheet>
                        <edit-view-term-reports v-if="termReports"></edit-view-term-reports>
                        <print-view-reports v-if="reports"></print-view-reports>
                        <employees v-if="employees"></employees>
                        <student-subjects v-if="studentSubjects"></student-subjects>
                        <Students v-if="editViewStudents"></Students>
                        <reset-password v-if="resetPassword"></reset-password>
                        <settings v-if="settings"></settings>
                    </v-col>                    
                </v-row>                    
                              
            </v-container> 
        </v-main> 

        <sweet-modal
            :icon="modalIcon"
            ref="modal"
            overlay-theme="dark"
            :title="modalTitle"
            v-on:close="closeModal"
        >
            {{ modalMessage }}
        </sweet-modal>

        <v-overlay
            :value="appOverlay"
            opacity="0.8"
            z-index="10"                    
        >
            
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>                   
        </v-overlay>
    </v-app>
</template>

<script>
import Logout from './auth/Logout';
import MainMenu from './MainMenu';
import MarkSheet from './MarkSheet';
import EditViewTermReports from './EditViewTermReports';
import PrintViewReports from './PrintViewReports';
import Employees from './Employees';
import StudentSubjects from './StudentSubjects';
import Students from './Students';
import ResetPassword from './ResetPassword';
import Settings from './Settings';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { SweetModal } from 'sweet-modal-vue';


export default {
    name: 'Admin',
    components: {
        Logout,        
        MainMenu,
        MarkSheet,
        EditViewTermReports,
        PrintViewReports,
        Employees,
        StudentSubjects,
        Students,
        ResetPassword,
        SweetModal,
        Settings,        
    },
    created(){ 
        this.initialize();                
    },
    watch: {
        modal:{
            handler(value){
                console.log('opening modal..')
                console.log(this.modalIcon);
                if(value) this.openModal();
            }
        }
    },
    computed: { 
        ...mapGetters({
            getUser: 'auth/getUser',
            schoolName: 'app/getSchoolName',
            primaryColor: 'app/getPrimaryColor',
            colorDarken: 'app/getColorDarken',
            user: 'auth/getEmployeeSignedIn',
            initials: 'auth/getEmployeeInitials',
            welcomeMessage: 'mainMenu/getWelcomeMessage',
            mainMenu: 'mainMenu/getDashboard',
            markSheet: 'mainMenu/getMarkSheet',
            termReports: 'mainMenu/getTermReports',
            reports: 'mainMenu/getReports',
            employees: 'mainMenu/getEmployees',
            studentSubjects: 'mainMenu/getStudentSubjects',
            editViewStudents: 'mainMenu/getEditViewStudents',
            resetPassword: 'mainMenu/getResetPassword',
            modal: 'app/getModal',
            modalTitle: 'app/getModalTitle',
            modalIcon: 'app/getModalIcon',
            modalMessage: 'app/getModalMessage',           
            appOverlay: 'app/getAppOverlay',
            settings: 'mainMenu/getSettings',
            currentAcademicPeriod: 'app/getCurrentAcademicPeriod',            
        }),
        titleClass(){
            return 'subtitle-1 font-weight-light font-italic  white--text';
        },
        textClass(){
            return 'd-flex justify-center text-body-1 primary--text';
        },
        textClassRight(){
            return 'd-flex mr-10 justify-center text-body-1 primary--text ';
        },
        avatarClass(){
            return 'secondary--text button'
        },
        buttonColor(){
            return 'primary';
        },
        schoolNameClass(){
            return 'd-flex align-center text-uppercase font-weight-bold primary--text';
        }        
    },
    
    data: () => ({                
        lastLogin: false,
        //currentAcademicPeriod: null,         
    }),
    
    methods: {
        ...mapMutations({
            setMainMenu: 'mainMenu/setMainMenu', 
            setMarkSheet: 'mainMenu/setMarkSheet',
            setTermReports: 'mainMenu/setTermReports',
            setPrintViewReports: 'mainMenu/setReports',
            setEmployees: 'mainMenu/setEmployees',
            setStudentSubjects: 'mainMenu/setStudentSubjects',
            setEditViewStudents: 'mainMenu/setEditViewStudents',
            setResetPassword: 'mainMenu/setResetPassword',                       
            setModal: 'app/setModal',
            setAppOverlay: 'app/setAppOverlay',
            setAcademicYearId: 'app/setAcademicYearId',
            setAcademicTermId: 'app/setAcademicTermId',
            setAcademicYear: 'app/setAcademicYear',
            setTerm: 'app/setTerm',
            setWelcomeMessage: 'mainMenu/setWelcomeMessage',
            setMarkSheetLoading: 'markSheet/setMarkSheetLoading',            
            setPresetComment: 'markSheet/setPresetComment',
            setSettings: 'mainMenu/setSettings',
            setCurrentAcademicPeriod: 'app/setCurrentAcademicPeriod',
        }),
        ...mapActions({
            academicPeriod: 'app/getAcademicPeriod',
        }),
        async initialize(){
            try {
                let response = await this.academicPeriod();                
                let academicYearId = response.data.academic_year_id;
                let academicTermId = response.data.id;
                let term = response.data.term; 
                
                this.setAcademicTermId(academicTermId);               
                this.setAcademicYearId(academicYearId);
                this.setTerm(term);                
                this.setCurrentPeriod(term, academicYearId);
                              
            } catch (error) {
                console.log(error);
            }           
            
            this.setAppOverlay(false);
        },
        setCurrentPeriod(term, academicYearId){
            let year = academicYearId.toString().substr(0, 4) + '-' + academicYearId.toString().substr(4);
            this.setAcademicYear(year);
            this.setCurrentAcademicPeriod(`Term: ${ term } Year: ${ year}`);  
        },        
        openModal(){            
            this.$refs.modal.open();
        },
        closeModal(){
            this.setModal(false);
        },
        showMainMenu(){                        
            this.setWelcomeMessage(true);
            this.setMarkSheetLoading(false);
            this.setMainMenu(true);
            this.setMarkSheet(false);
            this.setTermReports(false);
            this.setPrintViewReports(false);
            this.setEmployees(false);
            this.setStudentSubjects(false);
            this.setEditViewStudents(false);
            this.setResetPassword(false);
            this.setSettings(false);
        },        
    }
}
</script>

<style scoped>
    ::v-deep .v-btn--fab.v-size--default.v-btn--absolute.v-btn--top{
        top: 3px;
        right: 0;
    }

     /* ── App Bar ─────────────────────────────────────────────────── */
.appbar-logo {
  width: 60px;
  height: 50px;
  border-radius: 10px;
  background: rgba(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  /* flex-shrink: 0; */
}
 
.appbar-title {
  font-size: 13.5px !important;
  font-weight: 600 !important;
  color: white !important;
  letter-spacing: 0.9px !important;
}
 
.appbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
 
.term-badge {
  display: flex;
  align-items: center;
  gap: 5px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}
 
.user-avatar {
  background: rgba(255, 255, 255, 0.22) !important;
  border: 1.5px solid rgba(255, 255, 255, 0.4) !important;
  cursor: pointer;
  font-weight: 700;
  font-size: 13px;
  color: white !important;
}
 
.logout-btn {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 12px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
}
 
/* ── Main ────────────────────────────────────────────────────── */
.main-bg {
  background: #F0F2F8 !important;
}
 
/* ── Welcome Header ──────────────────────────────────────────── */
.welcome-header {
  background: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  padding: 18px 28px;
}
 
.welcome-eyebrow {
  margin: 0 0 2px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #9FA8DA;
}
 
.welcome-heading {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  color: #1A237E;
}
 
.welcome-name {
  font-style: italic;
  color: #5C6BC0;
  font-weight: 400;
}
 
/* ── Dashboard Grid ──────────────────────────────────────────── */
.dashboard-container {
  padding: 20px 20px;
}
 
.section-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: #9E9E9E;
  margin: 0 0 16px;
}
 

</style>